export const DEFAULT_SILO_BUSTING_CHART_DATA = {
  chart_data: [],
  can_show_chart_description_note: 0,
  choice_id_to_text_mapping: {}
};

export const getInitialSelection = (options, defaultId) => {
  if (defaultId) {
    const foundOption = options.find(option => option.id === defaultId);
    if (foundOption) return foundOption;
  }
  return options[0] || null;
}

export const getNodeToColorMapping = (chartData) => {
    // Color palette is yet to be updated with few more colors
    const colorPalette = [
      "#ff744d",
      "#5d1842",
      "#8aafb5",
      "#8b62d0",
      "#ecb483",
      "#01434f",
      "#d0441d",
      "#c5b2e5",
      "#346972",
      "#e577a5",
      "#002d9c",
      "#e69956",
      "#7f4165",
      "#7cb5ec",
      "#aa3515",
      "#1192e8",
      "#a41a54",
      "#e4d354",
      "#a88adb",
      "#198038",
      "#4758b4"
    ]

    const nodeMapping = {};
    const uniqueNodes = computeAndSortNodeWeights(chartData);

    uniqueNodes.forEach((node, index) => {
        nodeMapping[node] = colorPalette[index];
    });

    return nodeMapping;
}

export const computeAndSortNodeWeights = (data) => {
  const weights = {};

  // Sum weights for each node appearance
  data.forEach(([from, to, value]) => {
    weights[from] = (weights[from] || 0) + value;
    weights[to]   = (weights[to]   || 0) + value;
  });

  // Sort result descending by node weight
  return Object.entries(weights)
    .sort((a, b) => b[1] - a[1])       // [node, weight]
    .map(([node]) => node);            // return only node names in sorted order
}


export const getNodeDataFromNodeMapping = (nodeMapping) => {
  return Object.entries(nodeMapping).map(([nodeId, color]) => ({
    id: nodeId,
    color: color
  }));
}
